export const systemKey = [
  { name: "MouseKey0", value: 0x01, down: 0x20, up: 0xa0 },
  { name: "MouseKey1", value: 0x02, down: 0x20, up: 0xa0 },
  { name: "MouseKey2", value: 0x04, down: 0x20, up: 0xa0 },
  { name: "MouseKey3", value: 0x10, down: 0x20, up: 0xa0 },
  { name: "MouseKey4", value: 0x08, down: 0x20, up: 0xa0 },

  { name: "MouseKeyPrimary", value: 0x01, down: 0x20, up: 0xa0 },
  { name: "MouseKeySecondary", value: 0x02, down: 0x20, up: 0xa0 },
  { name: "MouseKeyAuxiliarv", value: 0x04, down: 0x20, up: 0xa0 },
  { name: "MouseKeyForward", value: 0x10, down: 0x20, up: 0xa0 },
  { name: "MouseKeyBack", value: 0x08, down: 0x20, up: 0xa0 },

  { name: "Escape", value: 0x29, down: 0x00, up: 0x80 },
  { name: "F1", value: 0x3a, down: 0x00, up: 0x80 },
  { name: "F2", value: 0x3b, down: 0x00, up: 0x80 },
  { name: "F3", value: 0x3c, down: 0x00, up: 0x80 },
  { name: "F4", value: 0x3d, down: 0x00, up: 0x80 },
  { name: "F5", value: 0x3e, down: 0x00, up: 0x80 },
  { name: "F6", value: 0x3f, down: 0x00, up: 0x80 },
  { name: "F7", value: 0x40, down: 0x00, up: 0x80 },
  { name: "F8", value: 0x41, down: 0x00, up: 0x80 },
  { name: "F9", value: 0x42, down: 0x00, up: 0x80 },
  { name: "F10", value: 0x43, down: 0x00, up: 0x80 },
  { name: "F11", value: 0x44, down: 0x00, up: 0x80 },
  { name: "F12", value: 0x45, down: 0x00, up: 0x80 },

  { name: "Delete", value: 0x4c, down: 0x00, up: 0x80 },
  { name: "Home", value: 0x4a, down: 0x00, up: 0x80 },
  { name: "End", value: 0x4d, down: 0x00, up: 0x80 },
  { name: "PageUp", value: 0x4b, down: 0x00, up: 0x80 },
  { name: "PageDown", value: 0x4e, down: 0x00, up: 0x80 },

  { name: "Backquote", value: 0x35, down: 0x00, up: 0x80 },
  { name: "Digit1", value: 0x1e, down: 0x00, up: 0x80 },
  { name: "Digit2", value: 0x1f, down: 0x00, up: 0x80 },
  { name: "Digit3", value: 0x20, down: 0x00, up: 0x80 },
  { name: "Digit4", value: 0x21, down: 0x00, up: 0x80 },
  { name: "Digit5", value: 0x22, down: 0x00, up: 0x80 },
  { name: "Digit6", value: 0x23, down: 0x00, up: 0x80 },
  { name: "Digit7", value: 0x24, down: 0x00, up: 0x80 },
  { name: "Digit8", value: 0x25, down: 0x00, up: 0x80 },
  { name: "Digit9", value: 0x26, down: 0x00, up: 0x80 },
  { name: "Digit0", value: 0x27, down: 0x00, up: 0x80 },

  { name: "Minus", value: 0x2d, down: 0x00, up: 0x80 },
  { name: "Equal", value: 0x2e, down: 0x00, up: 0x80 },
  { name: "Backspace", value: 0x2a, down: 0x00, up: 0x80 },
  { name: "NumLock", value: 0x53, down: 0x00, up: 0x80 },
  { name: "NumpadDivide", value: 0x54, down: 0x00, up: 0x80 },
  { name: "NumpadMultiply", value: 0x55, down: 0x00, up: 0x80 },
  { name: "NumpadSubtract", value: 0x56, down: 0x00, up: 0x80 },

  { name: "Tab", value: 0x2b, down: 0x00, up: 0x80 },
  { name: "KeyQ", value: 0x14, down: 0x00, up: 0x80 },
  { name: "KeyW", value: 0x1a, down: 0x00, up: 0x80 },
  { name: "KeyE", value: 0x08, down: 0x00, up: 0x80 },
  { name: "KeyR", value: 0x15, down: 0x00, up: 0x80 },
  { name: "KeyT", value: 0x17, down: 0x00, up: 0x80 },
  { name: "KeyY", value: 0x1c, down: 0x00, up: 0x80 },
  { name: "KeyU", value: 0x18, down: 0x00, up: 0x80 },
  { name: "KeyI", value: 0x0c, down: 0x00, up: 0x80 },
  { name: "KeyO", value: 0x12, down: 0x00, up: 0x80 },
  { name: "KeyP", value: 0x13, down: 0x00, up: 0x80 },
  { name: "BracketLeft", value: 0x2f, down: 0x00, up: 0x80 },
  { name: "BracketRight", value: 0x30, down: 0x00, up: 0x80 },
  { name: "Backslash", value: 0x31, down: 0x00, up: 0x80 },

  { name: "Numpad7", value: 0x5f, down: 0x00, up: 0x80 },
  { name: "Numpad8", value: 0x60, down: 0x00, up: 0x80 },
  { name: "Numpad9", value: 0x61, down: 0x00, up: 0x80 },
  { name: "NumpadAdd", value: 0x57, down: 0x00, up: 0x80 },
  { name: "CapsLock", value: 0x39, down: 0x00, up: 0x80 },
  { name: "KeyA", value: 0x04, down: 0x00, up: 0x80 },
  { name: "KeyS", value: 0x16, down: 0x00, up: 0x80 },
  { name: "KeyD", value: 0x07, down: 0x00, up: 0x80 },
  { name: "KeyF", value: 0x09, down: 0x00, up: 0x80 },
  { name: "KeyG", value: 0x0a, down: 0x00, up: 0x80 },
  { name: "KeyH", value: 0x0b, down: 0x00, up: 0x80 },
  { name: "KeyJ", value: 0x0d, down: 0x00, up: 0x80 },
  { name: "KeyK", value: 0x0e, down: 0x00, up: 0x80 },
  { name: "KeyL", value: 0x0f, down: 0x00, up: 0x80 },
  { name: "Semicolon", value: 0x33, down: 0x00, up: 0x80 },
  { name: "Quote", value: 0x34, down: 0x00, up: 0x80 },
  { name: "Enter", value: 0x28, down: 0x00, up: 0x80 },

  { name: "Numpad4", value: 0x5c, down: 0x00, up: 0x80 },
  { name: "Numpad5", value: 0x5d, down: 0x00, up: 0x80 },
  { name: "Numpad6", value: 0x5e, down: 0x00, up: 0x80 },
  { name: "ShiftLeft", value: 0xe1, down: 0x10, up: 0x90 },
  { name: "KeyZ", value: 0x1d, down: 0x00, up: 0x80 },
  { name: "KeyX", value: 0x1b, down: 0x00, up: 0x80 },
  { name: "KeyC", value: 0x06, down: 0x00, up: 0x80 },
  { name: "KeyV", value: 0x19, down: 0x00, up: 0x80 },
  { name: "KeyB", value: 0x05, down: 0x00, up: 0x80 },
  { name: "KeyN", value: 0x11, down: 0x00, up: 0x80 },
  { name: "KeyM", value: 0x10, down: 0x00, up: 0x80 },
  { name: "Comma", value: 0x36, down: 0x00, up: 0x80 },
  { name: "Period", value: 0x37, down: 0x00, up: 0x80 },
  { name: "Slash", value: 0x38, down: 0x00, up: 0x80 },

  { name: "PrintScreen", value: 0x46, down: 0x00, up: 0x80 },
  { name: "ScrollLock", value: 0x47, down: 0x00, up: 0x80 },
  { name: "Pause", value: 0x48, down: 0x00, up: 0x80 },
  { name: "Insert", value: 0x49, down: 0x00, up: 0x80 },

  { name: "ShiftRight", value: 0xe5, down: 0x10, up: 0x90 },
  { name: "ArrowUp", value: 0x52, down: 0x00, up: 0x80 },
  { name: "Numpad1", value: 0x59, down: 0x00, up: 0x80 },
  { name: "Numpad2", value: 0x5a, down: 0x00, up: 0x80 },
  { name: "Numpad3", value: 0x5b, down: 0x00, up: 0x80 },
  { name: "NumpadEnter", value: 0x58, down: 0x00, up: 0x80 },
  {
    name: "ControlLeft",
    value: 0xe0,
    down: 0x10,
    up: 0x90,
  },
  { name: "MetaLeft", value: 0xe3, down: 0x10, up: 0x90 },
  { name: "ContextMenu", value: 0xe7, down: 0x10, up: 0x90 },

  { name: "AltLeft", value: 0xe2, down: 0x10, up: 0x90 },
  { name: "Space", value: 0x2c, down: 0x00, up: 0x80 },
  { name: "AltRight", value: 0xe6, down: 0x10, up: 0x90 },
  {
    name: "ControlRight",
    value: 0xe4,
    down: 0x10,
    up: 0x90,
  },
  { name: "ArrowLeft", value: 0x50, down: 0x00, up: 0x80 },
  { name: "ArrowDown", value: 0x51, down: 0x00, up: 0x80 },
  { name: "ArrowRight", value: 0x4f, down: 0x00, up: 0x80 },
  { name: "Numpad0", value: 0x62, down: 0x00, up: 0x80 },
  { name: "NumpadDecimal", value: 0x63, down: 0x00, up: 0x80 },

  // 基础/修饰键补充
  { name: "None", value: 0x00, down: 0x00, up: 0x80 },
  { name: "OSLeft", value: 0xe3, down: 0x10, up: 0x90 },
  { name: "OSRight", value: 0xe7, down: 0x10, up: 0x90 },

  // Numpad 补充
  { name: "NumpadEqual", value: 0x67, down: 0x00, up: 0x80 },
  { name: "NumpadParenLeft", value: 0xb6, down: 0x00, up: 0x80 },
  { name: "NumpadParenRight", value: 0xb7, down: 0x00, up: 0x80 },

  // Media 补充
  { name: "MediaPlayPause", value: 0x00cd, down: 0x00, up: 0x80 },
  { name: "AudioVolumeMute", value: 0x00e2, down: 0x00, up: 0x80 },
  { name: "MediaTrackPrevious", value: 0x00b6, down: 0x00, up: 0x80 },
  { name: "MediaTrackNext", value: 0x00b5, down: 0x00, up: 0x80 },
  { name: "AudioVolumeUp", value: 0x00e9, down: 0x00, up: 0x80 },
  { name: "AudioVolumeDown", value: 0x00ea, down: 0x00, up: 0x80 },
  { name: "Power", value: 0x10000001, down: 0x00, up: 0x80 },
  { name: "Sleep", value: 0x10000002, down: 0x00, up: 0x80 },
  { name: "Wakeup", value: 0x10000004, down: 0x00, up: 0x80 },
  { name: "BrowserHome", value: 0xac, down: 0x00, up: 0x80 },

  // Edit 补充
  { name: "Undo", value: 0x7a, down: 0x00, up: 0x80 },
  { name: "Paste", value: 0x7d, down: 0x00, up: 0x80 },
  { name: "Cut", value: 0x7b, down: 0x00, up: 0x80 },
  { name: "Copy", value: 0x7c, down: 0x00, up: 0x80 },
  { name: "Help", value: 0x75, down: 0x00, up: 0x80 },
];

export function getSystemKey(name: string) {
  for (let i = 0; i < systemKey.length; i++) {
    if (systemKey[i].name === name) {
      return systemKey[i];
    }
  }
  return null;
}
